export default __webpack_public_path__ + "static/modal-background-pubertad-df08fdbc1d592d7543f009a996d533cd.png";